import AOS from "aos";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "../../assets/css/corporate.css";
import data from "../ApiUrl/meta_api.js";

function CorporateTrainings() {
  const [meta, setMeta] = useState(null);
  
  const fetchData = () => {
    const HomeMeta = data[0]?.corporate_training_page;
    if (HomeMeta) {
      setMeta(HomeMeta);
    }
  };
    useEffect(() => {
      fetchData();
      AOS.init({
        duration: 2000,
        once: true,
      });
    }, []);

  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "CorporateTrainings"}</title>
        <link rel="canonical" href="https://skimitaracademy.com/corporatetrainings"/>
      </Helmet>{" "}
      <div
        className="backgroundCommenImage mb-5"
        style={{
          backgroundImage: `url(${require("../../assets/images/Intern/Corporate Trainings/people-taking-part-business-event.webp")})`,
        }}
      >
        {" "}
        <div className="backgroundcommenImageBannerText">

        </div>
      </div>
      <div className="container" >
        <h1 className="text-danger text-center">
          Corporate Training Programs
        </h1>
        <div className="container">
          <p className="text-dark text-justify">
            Skimitar Hindusthan, we specialize in providing customized
            corporate training solutions tailored to the unique needs of your
            organization. Whether you're looking to upskill your workforce in
            Industrial Automation or enhance your team's expertise in Digital
            Marketing, we deliver impactful training that drives results.
          </p>
        </div>
      </div>
      <div className="container mt-5 mb-5">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <img
              className="seconsection"
              src={require("../../assets/images/Intern/Corporate Trainings/c8.webp")}
              // style={{ height: "100%", width: "90%" }}
            ></img>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 text-start">
            <h3 className="text-danger indus_corp">
              Industrial Automation Corporate Training
            </h3>

            <p className="CorporateTraining">
              Equip your team with advanced knowledge and hands-on experience in
              Industrial Automation. Our training modules cover
            </p>

            <p className="CorporateTraining">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545",fontSize: "12px" }}></i>{" "}
              PLC Programming: Comprehensive sessions on Mitsubishi, Siemens,
              and Allen-Bradley PLCs.
            </p>

            <p className="CorporateTraining">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545",fontSize: "12px" }}></i>{" "}
              SCADA Systems: Mastery of real-time data monitoring and control.
            </p>

            <p className="CorporateTraining">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" ,fontSize: "12px"}}></i>{" "}
              HMI Design: Building user-friendly interfaces for industrial
              applications.
            </p>

            <p className="CorporateTraining">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545",fontSize: "12px" }}></i>{" "}
              Automation Integration: Strategies for integrating automation into
              existing workflows.
            </p>
            <p className="CorporateTraining">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545",fontSize: "12px" }}></i>{" "}
              Troubleshooting & Maintenance: Techniques for optimizing and
              maintaining automation systems.
            </p>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <h3 className="text-danger digi_corp">
              Digital Marketing Corporate Training
            </h3>

            <p className="DigitalMarket">
              Stay ahead in the digital era by empowering your workforce with
              cutting-edge Digital Marketing skills. Our training covers
            </p>

            <p className="DigitalMarket">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545",fontSize: "12px" }}></i>{" "}
              Search Engine Optimization (SEO): Techniques to improve your
              online visibility.
            </p>

            <p className="DigitalMarket">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545",fontSize: "12px" }}></i>{" "}
              Social Media Marketing (SMM): Leveraging platforms like Facebook,
              Instagram, and LinkedIn for business growth.
            </p>

            <p className="DigitalMarket">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545",fontSize: "12px" }}></i>{" "}
              Pay-Per-Click (PPC) Advertising: Maximizing ROI on your ad spend.
            </p>

            <p className="DigitalMarket">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" ,fontSize: "12px"}}></i>{" "}
              Content Marketing: Creating engaging and impactful content.
            </p>

            <p className="DigitalMarket">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545",fontSize: "12px" }}></i>{" "}
              Email Marketing: Building effective email campaigns to reach your
              audience.
            </p>

            <p className="DigitalMarket">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545",fontSize: "12px" }}></i>{" "}
              Analytics & Insights: Data-driven strategies to measure and
              improve campaign performance.
            </p>
          </div>
          <div className="col-lg-6">
            {/* <img
              className=""
              src={require("../../assets/images/Services/Digital Marketing/pexels-mikael-blomkvist-6476589.webp")}
              style={{ height: "100%", width: "100%" }}
            ></img> */}
             <img
              className=""
              src={require("../../assets/images/Intern/Corporate Trainings/pexels-artempodrez-5716001.webp")}
              style={{ height: "100%", width: "100%" }}
            ></img>
          </div>
        </div>
      </div>
      {/* <div className="container mt-5">
        <div className="row">
          <div className="col-lg-6 ">
            <h4 className="text-danger">Why Our Training Stands Out?</h4>

            <p className="p-3">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" }}></i>{" "}
              Up-to-date modules aligned with the latest industry trends.
            </p>

            <p className="p-3">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" }}></i>{" "}
              Case studies and practical exercises.
            </p>

            <p className="p-3">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" }}></i>{" "}
              Certification to validate your team's new skills.
            </p>
          </div>
          <div className="col-lg-6">
            <h4 className="text-danger">Our Approach</h4>

            <p className="p-3">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" }}></i>{" "}
              Needs Analysis: We assess your organization's goals and tailor our
              training.
            </p>

            <p className="p-3">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" }}></i>{" "}
              Hands-On Learning: Practical applications to ensure skill
              transfer.
            </p>

            <p className="p-3">
              <i class="fa-solid fa-circle" style={{ color: "#dc3545" }}></i>{" "}
              Post-Training Support: Continued assistance to help your team
              implement.
            </p>
          </div>
        </div>
      </div> */}
      <div className="container mt-5 mb-5">
        <div className="row">
          <div className="col-lg-12">
            <h3 className="text-danger text-center">
              Join Leading Companies Trusting <br></br> Skimitar Hindusthan
            </h3>

            <p className=" JoinLead">
              Empower your workforce with the skills they need to excel in their
              roles. Contact us today to learn how we can help you build a
              stronger, more capable team. Skimitar Hindusthan has earned the
              trust of leading companies across industries by delivering
              innovative and reliable solutions tailored to modern business
              challenges. Renowned for its commitment to quality, efficiency,
              and excellence 
            </p>

            <p className="JoinLead">
            Skimitar Hindusthan empowers organizations to
              achieve their goals with cutting-edge products and services. By
              partnering with Skimitar Hindusthan, businesses benefit from a
              proven track record of success, unmatched expertise, and a
              customer-centric approach that ensures long-term value. Join the
              growing network of industry leaders who trust Skimitar Hindusthan
              to drive innovation and growth in today's competitive landscape.
            </p>
          </div>
        
        </div>
      </div>
    </>
  );
}

export default CorporateTrainings;
